/* Sticky buy bar: reveal once the reader is past the hero, hide again once
   they have reached the product grid (the bar would only cover it). */

class LpStickyCta extends HTMLElement {
  connectedCallback() {
    this.threshold = Number(this.dataset.showAfter) || 700;
    this.grid = document.querySelector('#lp-shop');

    this.onScroll = this.onScroll.bind(this);
    addEventListener('scroll', this.onScroll, { passive: true });
    addEventListener('resize', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    removeEventListener('scroll', this.onScroll);
    removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;

      const past = scrollY > this.threshold;
      // Once the grid itself is on screen the reader has a real buy button.
      const gridVisible =
        this.grid && this.grid.getBoundingClientRect().top < innerHeight * 0.85;

      const show = past && !gridVisible;
      if (show === this.shown) return;
      this.shown = show;

      if (show) {
        this.hidden = false;
        requestAnimationFrame(() => this.classList.add('is-visible'));
      } else {
        this.classList.remove('is-visible');
        // Wait out the transition before removing it from the a11y tree.
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
          if (!this.shown) this.hidden = true;
        }, 250);
      }
    });
  }
}

if (!customElements.get('lp-sticky-cta')) {
  customElements.define('lp-sticky-cta', LpStickyCta);
}
